import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { registerFormschema } from '../../../util/validationSchema'
import { MainLogo } from '../../../helper/imagepath'

const Register = () => {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const onPasswordEyeClick = () => setShowPassword(!showPassword)
  const onConfirmPasswordEyeClick = () => setShowConfirmPassword(!showConfirmPassword)

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({ resolver: yupResolver(registerFormschema) })

  const onSubmit = (data) => {
    console.log('data :>> ', data)
  }

  return (
    <div className="main-wrapper  login-body">
      <div className="login-wrapper">
        <div className="container">
          <img className="img-fluid logo-dark mb-2" src={MainLogo} alt="Logo" />

          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>Register</h1>
                <p className="account-subtitle">Access to our dashboard</p>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group input_text">
                    <label className="form-control-label">Name</label>
                    <Controller
                      name="fullname"
                      type="text"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control ${errors?.fullname ? 'error-input' : ''}`}
                          type="text"
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                        />
                      )}
                      defaultValue=""
                    />

                    <small>{errors?.fullname?.message}</small>
                  </div>
                  <div className="form-group input_text">
                    <label className="form-control-label">Email Address</label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control  ${errors?.email ? 'error-input' : ''}`}
                          type="text"
                          value={value}
                          onChange={onChange}
                          autoComplete="false"
                        />
                      )}
                      defaultValue=""
                    />

                    <small>{errors?.email?.message}</small>
                  </div>
                  <div className="form-group input_text">
                    <label className="form-control-label">Password</label>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <div className="pass-group">
                          <input
                            type={showPassword ? 'text' : 'password'}
                            className={`form-control  ${errors?.password ? 'error-input' : ''}`}
                            value={value}
                            onChange={onChange}
                            autoComplete="false"
                          />
                          <span onClick={onPasswordEyeClick} className={`fa toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                        </div>
                      )}
                      defaultValue=""
                    />

                    <small>{errors?.password?.message}</small>
                  </div>
                  <div className="form-group input_text">
                    <label className="form-control-label">Confirm Password</label>
                    <Controller
                      name="confirmPassword"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <div className="pass-group">
                          <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            className={`form-control  ${errors?.confirmPassword ? 'error-input' : ''}`}
                            value={value}
                            onChange={onChange}
                            autoComplete="false"
                          />
                          <span
                            onClick={onConfirmPasswordEyeClick}
                            className={`fa toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`}
                          />
                        </div>
                      )}
                      defaultValue=""
                    />
                    <small>{errors?.confirmPassword?.message}</small>
                  </div>
                  <button className="btn btn-lg btn-block w-100 btn-primary w-100" type="submit">
                    Register
                  </button>
                </form>

                <div className="login-or">
                  <span className="or-line"></span>
                  <span className="span-or">or</span>
                </div>

                <div className="social-login">
                  <span>Register with</span>
                  <Link to="#" className="facebook">
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link to="#" className="google">
                    <i className="fab fa-google"></i>
                  </Link>
                </div>

                <div className="text-center dont-have">
                  Already have an account? <Link to="/login">Login</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Register
